import { FormApi } from 'final-form';
import { IAccount } from 'store/accounts.model';
import { IApiResponse } from 'utils/models';

export const transferTypes = ['Local Transfer', 'International Transfer'] as const;
export type TransferType = typeof transferTypes[number];

export const currencies = ['GBP', 'USD', 'EUR'] as const;
export type Currency = typeof currencies[number];

export const feesToBePaidBy = ['Sender', 'Beneficiary'] as const;
export type FeesToBePaidBy = typeof feesToBePaidBy[number];

export interface IFormValues {
  transferType: TransferType;
  currency: Currency;
  sourceAccount: string;
  amount: string;
  beneficiaryName: string;
  beneficiaryAccount: string;
  beneficiaryCountry: string;
  beneficiaryBankName: string;
  beneficiaryBankAddress: string;
  swiftCode: string;
  sortCode: string;
  routingNumber?: string;
  senderTelNumber: string;
  feePaidBy: FeesToBePaidBy;
  accountForCharges: string;
  purpose: string;
}

export type FormType = FormApi<IFormValues, Partial<IFormValues>>;

export interface IBank {
  BankName: string;
  BankSortCode: string;
}

export interface IBanksResponse extends IApiResponse {
  banks: IBank[];
}

export interface IFXState {
  accounts: IAccount[];
  banks: IBank[];
}
